import { render, staticRenderFns } from "./DoSeach.vue?vue&type=template&id=52a6f2a5&scoped=true&"
import script from "./DoSeach.vue?vue&type=script&lang=js&"
export * from "./DoSeach.vue?vue&type=script&lang=js&"
import style0 from "./DoSeach.vue?vue&type=style&index=0&id=52a6f2a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6f2a5",
  null
  
)

export default component.exports